(() => {
  const cartSelectors = ['.cart-page', '.cart-page__summary', '.cart-items-component', 'cart-items-component'];
  const isCartPage = () => cartSelectors.some((selector) => document.querySelector(selector));

  function mountCartPromise() {
    const summary = document.querySelector('.cart-page__summary');
    if (!summary || summary.querySelector('.sla-cart-promise')) return;

    const promise = document.createElement('div');
    promise.className = 'sla-cart-promise';
    promise.setAttribute('aria-label', 'Warenkorb Vorteile');
    promise.innerHTML = [
      '<div class="sla-cart-promise__item"><span class="sla-cart-promise__dot" aria-hidden="true"></span><span>Sichere Zahlung ueber Shopify Checkout.</span></div>',
      '<div class="sla-cart-promise__item"><span class="sla-cart-promise__dot" aria-hidden="true"></span><span>Schneller Versand und transparente Kosten im Checkout.</span></div>',
      '<div class="sla-cart-promise__item"><span class="sla-cart-promise__dot" aria-hidden="true"></span><span>Einfache Rueckgabe nach den Shop-Bedingungen.</span></div>'
    ].join('');
    summary.appendChild(promise);
  }

  function improveRemoveButtons() {
    for (const button of document.querySelectorAll('.cart-items__remove')) {
      const label = button.getAttribute('aria-label') || 'Artikel entfernen';
      if (button.getAttribute('title') !== label) button.setAttribute('title', label);
      if (button.dataset.label !== 'Entfernen') button.dataset.label = 'Entfernen';
    }
  }

  function mountEmptyCartNote() {
    const emptyCart = document.querySelector('.cart-page--empty');
    if (!emptyCart || emptyCart.querySelector('.sla-empty-cart-note')) return;

    const note = document.createElement('p');
    note.className = 'sla-empty-cart-note';
    note.textContent = 'Starte mit Bestsellern oder waehle Equipment nach Trainingsziel. Dein Warenkorb bleibt uebersichtlich und laesst sich jederzeit anpassen.';
    const button = emptyCart.querySelector('.cart-items__empty-button');
    if (button) button.insertAdjacentElement('beforebegin', note);
    else emptyCart.appendChild(note);
  }

  function improveCheckoutCopy() {
    for (const button of document.querySelectorAll('.cart__checkout-button')) {
      if (button.dataset.slaLabelApplied) continue;
      button.dataset.slaLabelApplied = 'true';
      button.setAttribute('aria-label', 'Sicher zum Checkout');
    }
  }

  function run() {
    if (!isCartPage()) return;
    mountCartPromise();
    improveRemoveButtons();
    mountEmptyCartNote();
    improveCheckoutCopy();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('cart:update', run);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
